import { useEffect, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import {
  loadLocalMedia,
  checkMediaPermission
} from 'ultils'
import { createEmptyMediaStream } from 'ultils/webrtc'
import { isGoogleAdsUser, needsCameraConsent } from 'ultils/adSource'
import {
  setMainContent,
  setLocalStream,
  setRegisterModal,
  setMainContentMobile,
  setIsFullScreen,
  setUpgradeModal,
  setMinutePackagesModal
} from 'actions'
import { connect } from 'react-redux'
import { toast } from 'components/common/Toast'
import { VideoCamera, Search } from 'assets/icons/components'
import {
  CameraRequestModal,
  NoCameraModal,
  RegisterPromoModal,
  WarningModal,
  GestureVerificationModal
} from 'components/common'
import MalePremiumBox from './MalePremiumBox'
import FemaleMonetizationBox from './FemaleMonetizationBox'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import { ChristmasBonus, SearchUnavailable, Switch } from 'components//common/index'
import {
  Action,
  ActionViewStories,
  ActionContainer,
  Text,
  ActionSearchContainer,
  ActionBonus,
  ActionSearchText,
  ActionWrapper,
  ModelEarningText,
  EnableCameraContainer,
  CameraText,
  BackgroundContainer,
  TopLeftCorner,
  TopRightCorner,
  BottomLeftCorner,
  BottomRightCorner,
  TopLeftText,
  TopRightText,
  BottomLeftText,
  AnimationContainer,
  AnimationText,
  AnimationTextSecond,
  AnimationTextContainer,
  AnimationIcon,
  ActionBonusMobile,
  SearchRow,
  AvatarModalHost
} from './style'
import { setStoriesModal, showConfirmEmailModal } from 'actions/mainContent'
import config from 'config'
import { setEnableCamera, setIsShowBestGirls, setSearching } from 'actions/videoCall'
import { ECHO_CALL_ENDED } from 'constants/realtimeEvent'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import AvatarModal from 'components/common/AvatarModal'

import moment from 'moment'

const Dashboard = (props) => {
  const { t } = useTranslation('live', { i18n })
  const { searchUnavailable, dispatch, isOnCall, localStream, user,
    isShowBestGirls, isShowConfirmEmailModal, countTime, isConfirmSearch, newEvent
  } = props
  const [isShowCameraRequestModal, setIsShowCameraRequestModal] = useState(false)
  const [isShowNoCameraModal, setIsShowNoCameraModal] = useState(false)
  const [isShowRegisterPromoModal, setIsShowRegisterPromoModal] = useState(false)
  const [background, setBackground] = useState('/images/background.jpg')
  const [isLoading, setIsLoading] = useState(false)
  const [nextAction, setNextAction] = useState(null)
  const [clockTime, setClockTime] = useState("")
  const [textIndex, setTextIndex] = useState(0)
  const [isShowAvatarModal, setIsShowAvatarModal] = useState(false)
  const [isShowCameraConsent, setIsShowCameraConsent] = useState(false)
  const [isShowGestureVerification, setIsShowGestureVerification] = useState(false)

  // Search label shared by both Action buttons: request spinner, then the
  // normal label.
  const renderSearchLabel = ({ withIcon = false } = {}) => {
    if (isLoading) {
      return <Spinner as='span' animation='border' size='xl' role='status' className='button__icon--loading' />
    }
    return (
      <>
        { withIcon && <Search style={{ marginRight: '8px' }} /> }
        <span>{t('Start search')}</span>
      </>
    )
  }

  useEffect(() => {
    let interval = setInterval(() => {
      setClockTime(moment().format('A hh:mm'))
    }, 1000)

    let textInterval = setInterval(() => {
      setTextIndex((prevIndex) => (prevIndex + 1) % 3)
    }, 3800)

    return () => {
      clearInterval(interval)
      clearInterval(textInterval)
    }
  }, [])

  useEffect(() => {
    if (!isShowConfirmEmailModal && nextAction === 'search') {
      handleClickSearch(false)
      setNextAction(null)
    }
  }, [isShowConfirmEmailModal])

  // WarningModal records the acceptance and flips isConfirmSearch, which is the
  // only signal that separates accepting from declining — its onClose fires for
  // both. Picking the search back up here means the user doesn't have to press
  // Start search a second time.
  useEffect(() => {
    if (isConfirmSearch && nextAction === 'search-after-consent') {
      setNextAction(null)
      setIsShowCameraConsent(false)
      handleClickSearch(false)
    }
  }, [isConfirmSearch])

  // The server counts completed calls and says on the call-ended event when a
  // liveness check is due, so the modal opens where the call actually finished
  // rather than waiting to block the next search.
  //
  // Models only. The server already restricts the flag to female accounts; this
  // repeats it because the event is broadcast to both sides of a call and a
  // customer must never be blocked by it.
  useEffect(() => {
    if (user?.gender !== 1) return

    if (newEvent?.event === ECHO_CALL_ENDED && newEvent?.isGestureVerification) {
      setIsShowGestureVerification(true)
    }
  }, [newEvent])

  const handleClickSearch = async (isShowConfirmEmail = true) => {
    //if (user?.gender === 1 && !user?.has_avatar) {
     // setIsShowAvatarModal(true)
      //toast.error(t('Please upload a profile picture before starting your first call'))
      //return
    //}

    if (
      user?.gender === 1 && user?.monetization_status === 3 && !user?.model_agreement
    ) {
      dispatch(setMainContent('monetization'))
      dispatch(setIsFullScreen(false))
      return;
    }

    if (isShowConfirmEmail && user?.gender === 0 && user?.role === 'user' && !user?.email_confirmed) {
      dispatch(showConfirmEmailModal(true))
      setNextAction('search')
      return;
    }

    if (user?.gender === 1 && user?.monetization_status !== 3) {
      if (user?.role === 'guest') {
        dispatch(setRegisterModal(true))
      } else {
        if (user?.monetization_status !== null) {
          dispatch(setMainContent('monetization'))
          dispatch(setIsFullScreen(false))
          return;
        }
      }
    }

    if (!isOnCall) {
      // Google Ads traffic is asked for no device at all here — not the camera
      // and not the microphone. Nothing on this screen touches getUserMedia for
      // them, so no browser prompt appears; both are requested together later,
      // if and when they turn their camera on from inside the call.
      const isNoDeviceStart = isGoogleAdsUser(user)

      // The camera terms have to be accepted before the browser is ever asked
      // for the camera, so this sits ahead of setEnableCamera/loadLocalMedia.
      if (needsCameraConsent({ user, isConfirmSearch })) {
        setNextAction('search-after-consent')
        setIsShowCameraConsent(true)
        return;
      }

      dispatch(setEnableCamera(!isNoDeviceStart))
      dispatch(setSearching(false))
      if (user?.minutes_balance >= 10 || user?.gender === 1) {
        if (user?.account_tier === 2 || user?.account_tier === 0 || user?.gender === 1 || user?.account_tier === 1 && user?.called_balance <= config.LIMIT_FREE_USER_CALL_IN_SECONDS) {
          if (localStream) {
            dispatch(setMainContentMobile('dashboard'))
            dispatch(setMainContent('dashboard'))
            dispatch(setIsFullScreen(true))
          } else if (isNoDeviceStart) {
            // No enumerateDevices, no permission explainer and no
            // getUserMedia — every one of those either raises the prompt or
            // gates the search on hardware nobody is going to ask for. The
            // empty stream stands in so the call UI comes up unchanged.
            dispatch(setMainContentMobile('dashboard'))
            dispatch(setMainContent('dashboard'))
            dispatch(setLocalStream(createEmptyMediaStream()))
            dispatch(setIsFullScreen(true))
          } else {
            let media = await checkMediaPermission()
            let { audioinput, videoinput } = media
            if (audioinput.length < 1 || videoinput.length < 1) {
              setIsShowCameraRequestModal(true)
            }
            
            setIsLoading(true)
            await handleEnableCamera()
            setIsLoading(false)
          }
        } else {
          dispatch(setUpgradeModal(true))
        }

      } else {
        if (user?.role === 'user') {
          if (user?.account_tier !== 2) {
            dispatch(setUpgradeModal(true))
          } else {
            dispatch(setMinutePackagesModal(true))
          }
        }

        if (user?.role === 'guest') {
          setIsShowRegisterPromoModal(true)
        }

        toast.error(t('You do not have enough minutes to start a call.'))
      }
    } else {
      toast.error(t('You cannot search while having a call.'))
    }
  }

  const handleCloseNoCameraModal = () => {
    setIsShowNoCameraModal(false)
  }

  const handleEnableCamera = async () => {
    let stream = await loadLocalMedia()
    setIsShowCameraRequestModal(false)
    if (user?.role === 'guest') {
      setIsShowRegisterPromoModal(true)
    }
    if (stream) {
      dispatch(setMainContentMobile('dashboard'))
      dispatch(setMainContent('dashboard'))
      dispatch(setLocalStream(stream))
      dispatch(setIsFullScreen(true))
      setIsShowNoCameraModal(false)
    } else {
      setIsShowNoCameraModal(true)
    }
  }

  const handleRegisterPromoAction = () => {
    setIsShowRegisterPromoModal(false)
    dispatch(setRegisterModal(true))
  }

  const handleOpenStoriesModal = () => {
    dispatch(setStoriesModal({
      isShow: true
    }))
  }

  const handleShowConfirmModal = () => {
    if (user?.role === 'guest') {
      dispatch(setRegisterModal(true))
      return;
    }

    dispatch(showConfirmEmailModal(true))
  }

  const handleShowBestGirls = () => {
    if (user?.role === 'guest') {
      dispatch(setRegisterModal(true))
      return;
    }

    if (user?.account_tier !== 2) {
      dispatch(setUpgradeModal(true))
      return;
    }

    if (user?.minutes_balance / 60 < 100) {
      dispatch(setMinutePackagesModal(true))
      return;
    }

    dispatch(setIsShowBestGirls(!isShowBestGirls))
  }

  return (
    <>
      <div className='main-content__dashboard'>
        <BackgroundContainer>
          <TopLeftText>
            { t('REC') }
          </TopLeftText>
          <TopRightText>
            { `${ ("0" + parseInt(countTime / 60)).slice(-2) }:${("0" + countTime % 60).slice(-2)}`}
          </TopRightText>
          <BottomLeftText>
            { clockTime } <br/>
            { moment().format('MMM DD, YYYY') }
          </BottomLeftText>
          <TopLeftCorner />
          <TopRightCorner />
          <BottomLeftCorner />
          <BottomRightCorner />
        </BackgroundContainer>
        {
          searchUnavailable
          ?
            <SearchUnavailable></SearchUnavailable>
          :
          <></>
        }
        
        <RegisterPromoModal
          handleAction={handleRegisterPromoAction}
          setIsShowRegisterPromoModal={setIsShowRegisterPromoModal}
          isShowRegisterPromoModal={isShowRegisterPromoModal} />
        { isShowCameraConsent &&
          <WarningModal
            onClose={() => setIsShowCameraConsent(false)}
            onDecline={() => setNextAction(null)} /> }
        { isShowGestureVerification &&
          <GestureVerificationModal
            onPass={() => setIsShowGestureVerification(false)} /> }
        <CameraRequestModal
          isShowCameraRequestModal={isShowCameraRequestModal} />
        <NoCameraModal
          handleEnableCamera={handleEnableCamera}
          isShowNoCameraModal={isShowNoCameraModal}
          handleCloseNoCameraModal={handleCloseNoCameraModal} />
        {user?.gender === 0 ?
          <MalePremiumBox />
          : <FemaleMonetizationBox />}
        <div className='dashboard__search'>
          <ActionContainer>
            {/* { user?.gender === 0
              ?
                <>
                  <ActionViewStories onClick={() => handleOpenStoriesModal()}>
                    { t('View stories') }
                  </ActionViewStories>
                  <Text>{ t('or') }</Text>
                </>
              : <></>
            } */}
            {
              user?.gender === 0 && <AnimationIcon src="/images/search-camera.png" />
            }
            <ActionSearchContainer>
              {
                user?.gender === 1 && user?.monetization_status === 3 && user?.pay_block < 60
                ?
                  <ActionWrapper>
                    <ModelEarningText>
                      { t('Get points more easily for a limited time and move up faster in the tiers to get a higher payout.') }
                    </ModelEarningText>
                    <Action
                      onClick={() => handleClickSearch()}
                      disabled={isLoading}>
                      { renderSearchLabel() }
                    </Action>
                    { !isGoogleAdsUser(user) &&
                      <div className='search__enable-camera'>
                        <VideoCamera className='search__icon' /> { t('Enable your camera to start searching') }
                      </div>
                    }
                  </ActionWrapper>
                :
                <>
                  <AnimationContainer>
                    <AnimationTextContainer>
                      <AnimationText active={textIndex === 0}>
                        {t('Meet real people')}
                      </AnimationText>
                      <AnimationTextSecond active={textIndex === 0}>
                        {t('Talk face to face')}
                      </AnimationTextSecond>
                    </AnimationTextContainer>
                    <AnimationTextContainer>
                      <AnimationText active={textIndex === 1}>
                        {t('Instant video chat')}
                      </AnimationText>
                      <AnimationTextSecond active={textIndex === 1}>
                        {t('with real people')}
                      </AnimationTextSecond>
                    </AnimationTextContainer>
                    <AnimationTextContainer>
                      <AnimationText active={textIndex === 2}>
                        {t('1-on-1 video chat')}
                      </AnimationText>
                      <AnimationTextSecond active={textIndex === 2}>
                        {t('with real people')}
                      </AnimationTextSecond>
                    </AnimationTextContainer>
                  </AnimationContainer>
                  <SearchRow>
                    <Action
                      onClick={() => handleClickSearch()}
                      disabled={isLoading}
                      withConfirm={user?.gender === 0 && !user?.email_confirmed}
                    >
                      { renderSearchLabel({ withIcon: true }) }
                    </Action>
                    {
                      user?.gender === 0 && !user?.email_confirmed
                      ?
                        <ActionBonusMobile onClick={() => handleShowConfirmModal()}>
                          <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                          <ActionSearchText>
                            +5 mins
                          </ActionSearchText>
                        </ActionBonusMobile>
                      : <></>
                    }
                  </SearchRow>
                  {
                    user?.gender === 0
                    ?
                      <EnableCameraContainer style={{ marginTop: '15px' }}>
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip id={`tooltip-top`}>
                              {t('For users with 100 minutes')}
                            </Tooltip>
                          }>
                          <CameraText>
                            {t('Show only the best girls (?)')}
                          </CameraText> 
                        </OverlayTrigger>
                        <Switch id='toggle-camera' value={isShowBestGirls} onClick={() => handleShowBestGirls()} handleOnChange={() => {}} />
                      </EnableCameraContainer>
                    : <></>
                  }
                  { !isGoogleAdsUser(user) &&
                    <div className='search__enable-camera'>
                      <VideoCamera className='search__icon' /> { t('Enable your camera to start searching') }
                    </div>
                  }
                  
                </>
              }
              
              {
               user?.gender === 0 && !user?.email_confirmed
               ?
                  <ActionBonus onClick={() => handleShowConfirmModal()}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                    <ActionSearchText>
                      {t('5 minutes free')}
                    </ActionSearchText>
                  </ActionBonus>
               : <></>
              }
            </ActionSearchContainer>
          </ActionContainer>
        </div>
      </div>
      { user?.enable_christmas_bonus ? <ChristmasBonus /> : <></>}
      {
        isShowAvatarModal
        ?
          <AvatarModalHost>
            <AvatarModal onCompleted={() => setIsShowAvatarModal(false)} />
          </AvatarModalHost>
        : <></>
      }
    </>
  )
}

const mapStateToProps = (state) => ({
  isOnCall: state.videoCallReducer.isOnCall,
  localStream: state.videoCallReducer.localStream,
  user: state.connectionReducer.user,
  newEvent: state.echoReducer.newEvent,
  searchUnavailable: state.mainContentReducer.searchUnavailable,
  isShowBestGirls: state.videoCallReducer.isShowBestGirls,
  isShowConfirmEmailModal: state.mainContentReducer.isShowConfirmEmailModal,
  isConfirmSearch: state.mainContentReducer.isConfirmSearch,
})

export default connect(mapStateToProps)(Dashboard)